import { registerLocale } from 'i18n-iso-countries';
import deI18nISOCountries from 'i18n-iso-countries/langs/de.json';
import esI18nISOCountries from 'i18n-iso-countries/langs/es.json';
import frI18nISOCountries from 'i18n-iso-countries/langs/fr.json';
import nlI18nISOCountries from 'i18n-iso-countries/langs/nl.json';
export const registerLocales = () => {
  registerLocale(esI18nISOCountries);
  registerLocale(deI18nISOCountries);
  registerLocale(frI18nISOCountries);
  registerLocale(nlI18nISOCountries);
};

// supported locales at moment
// "de-DE",
// "de",
// "en-US",
// "en-GB",
// "en",
// "es-US",
// "es",
// "fr-FR",
// "fr",
// "nl-NL",
// "nl"